// The leader's gold crown (Jack, 2026-10-29, from his reference picture): a
// smooth, glossy cartoon crown with flared horns, a spade-tipped centre spike
// and a ridged band, no jewels, wide and low. Plain SVG markup so the game
// board iframe (window.JangleAvatars.crown) can draw it too. `id` keeps the
// gradient ids unique when several crowns share a page.
const BODY = "M20 60 C17 44 12 26 3 16 C10 16 17 21 22 30 C24 34 27 36 29 34 L34 24 C36 32 40 37 46 37"
  + " C52 37 56 32 55 25 C52 23 50 20 50 18 L60 3 L70 18 C70 20 68 23 65 25 C64 32 68 37 74 37"
  + " C80 37 84 32 86 24 L91 34 C93 36 96 34 98 30 C103 21 110 16 117 16 C108 26 103 44 100 60 Z";
const BAND = "M17 57 Q60 65 103 57 L101 74 Q60 83 19 74 Z";
// Drawn 120 x 80 and squashed to 70% height: wide and low (Jack).
const SQUASH = 0.7;
const SPARKS = [[0, 3, 0], [120, 4, 0.6], [112, 55, 1.2], [6, 53, 1.8], [60, -7, 0.9]];
const GLOSS = [
  [0, "#8a4f05", 0.55], [0.12, "#8a4f05", 0.15], [0.2, "#fff8d8", 0.75], [0.25, "#fff8d8", 0],
  [0.32, "#fff8d8", 0.45], [0.36, "#fff8d8", 0], [0.62, "#fff2b8", 0.15], [0.8, "#8a4f05", 0.15],
  [0.86, "#fff2b8", 0.4], [0.9, "#8a4f05", 0.3], [1, "#8a4f05", 0.6],
];
const EDGE = 'stroke="#7a4a0c" stroke-width="2.2" stroke-linejoin="round"';

export function crownSvg(id = "c") {
  const gold = `url(#gold${id})`, gloss = `url(#gloss${id})`;
  const ridges = [61.5, 67.5].map((y) => `<g fill="none" stroke-linecap="round">`
    + `<path d="M18 ${y} Q60 ${y + 8.5} 102 ${y}" stroke="#8a5410" stroke-width="1.8"/>`
    + `<path d="M18 ${y + 1.8} Q60 ${y + 10.3} 102 ${y + 1.8}" stroke="#fff1b0" stroke-opacity="0.75" stroke-width="1.1"/></g>`).join("");
  const sparks = SPARKS.map(([x, y, d]) => `<path class="leader-crown-spark" style="animation-delay:${d}s;transform-origin:${x}px ${y}px" `
    + `d="M${x} ${y - 7} Q${x} ${y} ${x + 7} ${y} Q${x} ${y} ${x} ${y + 7} Q${x} ${y} ${x - 7} ${y} Q${x} ${y} ${x} ${y - 7} Z" fill="#fffbe6"/>`).join("");
  return `<svg viewBox="-4 -10 128 72" width="100%" style="display:block;overflow:visible" aria-hidden="true">`
    + `<defs><linearGradient id="gold${id}" x1="0" y1="0" x2="0" y2="1">`
    + `<stop offset="0" stop-color="#ffe58a"/><stop offset="0.55" stop-color="#f6c445"/><stop offset="1" stop-color="#dc9a22"/></linearGradient>`
    + `<linearGradient id="gloss${id}" x1="0" y1="0" x2="1" y2="0">`
    + GLOSS.map(([o, c, a]) => `<stop offset="${o}" stop-color="${c}" stop-opacity="${a}"/>`).join("")
    + `</linearGradient></defs>`
    + `<g transform="scale(1 ${SQUASH})">`
    + `<path d="${BODY}" fill="${gold}" ${EDGE}/><path d="${BODY}" fill="${gloss}"/>`
    + `<path d="M8 19 C13 25 16 36 19 50" fill="none" stroke="#fff8d8" stroke-opacity="0.8" stroke-width="1.6" stroke-linecap="round"/>`
    + `<path d="M57 9 L54 18" fill="none" stroke="#fff8d8" stroke-opacity="0.8" stroke-width="1.4" stroke-linecap="round"/>`
    + `<path d="${BAND}" fill="${gold}" ${EDGE}/><path d="${BAND}" fill="${gloss}"/>`
    + ridges + `</g>` + sparks + `</svg>`;
}

// Crown look for the board: glow and twinkling sparkles (same as index.css),
// plus the halo float above the raider's head.
export const CROWN_CSS = ".leader-crown-spark{animation:leader-crown-twinkle 2.4s ease-in-out infinite;transform:scale(0)}"
  + "@keyframes leader-crown-twinkle{0%,60%,100%{transform:scale(0);opacity:0}20%{transform:scale(1);opacity:1}40%{transform:scale(.4);opacity:.6}}"
  + "@media (prefers-reduced-motion:reduce){.leader-crown-spark{animation:none;transform:scale(.8);opacity:.9}}";
